import {Component, Input, OnInit, signal} from '@angular/core';
import {HeaderDataService} from '../../../services/header_data.service';
import {DateTimeInstanceService} from "../../../services/date-time-instance.service";
import {StringDatePipe} from "../../../shared/pipes";
import { CommonModule} from "@angular/common";

@Component({
    selector: 'app-pdf-header',
    templateUrl: './pdf-header.component.html',
    imports: [
        CommonModule,
        StringDatePipe,
    ],
    styleUrls: ['./pdf-header.component.less']
})
export class PdfHeaderComponent implements OnInit {
    @Input() pdfHeader: string;
    rightLogo = signal('/admin/myfiles/download/right-logo.png')

    constructor(public dateInst: DateTimeInstanceService,
                public headerData: HeaderDataService) {
    }

    ngOnInit(): void {
    }

}
